(() => {
  'use strict';
  if (window.__SQ_SOURCE_BAG_CHAIN_LOADER_V5__) return;
  window.__SQ_SOURCE_BAG_CHAIN_LOADER_V5__ = true;
  window.__SQ_SOURCE_BAG_CHAIN_LOADER_V4__ = true;
  window.__SQ_SOURCE_BAG_CHAIN_LOADER__ = true;

  window.CCARD_SELECTOR = '.sq-universal-card,[data-sq-universal-card],product-card,.product-card,.product-slider-belt-card,.sq-smart-picks__item,[data-lcs-favorite-card],[data-sqyml2-card],[data-lcs-recommend-card],[data-product-id],.premium-recommend-card-shell';

  const current = new URL(document.currentScript?.src || location.href, location.href);
  const assetUrl = (filename) => {
    const url = new URL(current.href);
    url.pathname = url.pathname.replace(/[^/]*$/, filename);
    return url.href;
  };
  const findStyle = (filename) => [...document.querySelectorAll('link[rel="stylesheet"]')].find((link) => {
    try { return new URL(link.href, location.href).pathname.endsWith(`/${filename}`); }
    catch (_) { return false; }
  });
  const ensureStyle = (filename, moveToEnd = false) => {
    let link = document.querySelector(`link[data-sq-source-style="${filename}"]`) || findStyle(filename);
    if (!link) {
      link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = assetUrl(filename);
      document.head.appendChild(link);
    }
    link.dataset.sqSourceStyle = filename;
    if (moveToEnd && link.parentNode === document.head) document.head.appendChild(link);
    return link;
  };
  const ensureScript = (filename) => {
    const path = `/${filename}`;
    const existing = [...document.scripts].find((script) => {
      try { return new URL(script.src, location.href).pathname.endsWith(path); }
      catch (_) { return false; }
    });
    if (existing) return existing;
    const script = document.createElement('script');
    script.src = assetUrl(filename);
    script.defer = true;
    script.dataset.sqSourceChain = filename;
    document.head.appendChild(script);
    return script;
  };

  ['sq-expanded-card-source-part-1.css','sq-expanded-card-source-part-2.css','sq-expanded-card-source-part-3.css','sq-expanded-card-source-part-4a.css','sq-expanded-card-source-part-4b.css','sq-expanded-card-source-part-4c.css','sq-expanded-card-source-part-5.css']
    .forEach((filename) => ensureStyle(filename));

  ensureStyle('sq-universal-bag-choose-complete-v1.css', true);
  ensureStyle('sq-expanded-color-label-clean-v2.css', true);
  ensureStyle('sq-expanded-card-swatch-surface-v1.css', true);
  ensureStyle('sq-favorite-active-pink.css', true);
  ensureStyle('sq-favorite-neutral-hover.css', true);
  ensureStyle('sq-world-door-glass-v1.css', true);
  ensureStyle('sq-universal-card-controls-authority-v2.css', true);
  ensureStyle('sq-favorite-selected-persistent.css', true);
  ensureStyle('sq-card-control-surface-parity-v1.css', true);
  ensureStyle('sq-home-featured-heart-match.css', true);
  ensureStyle('sq-home-mobile-moment-white-v1.css', true);
  ensureStyle('sq-mobile-interaction-authority-v1.css', true);
  /* Final visual owner: the shopping bag stays circular in every state.
     The old CHOOSE stylesheet remains loaded because it also owns shared expanded-card styling. */
  ensureStyle('sq-universal-bag-circle-direct-v1.css', true);

  /* Filter positioning remains owned by sq-filter-final-dna-v1.js. The drawer
     interaction owner is tiny and is guaranteed on every collection/search page. */
  const pagePath = (location.pathname || '/').replace(/\/+$/, '').toLowerCase() || '/';
  if (/^\/collections\//.test(pagePath) || pagePath === '/search') {
    ensureScript('sq-mobile-filter-drawer-universal-v1.js');
  }

  ensureScript('sq-source-universal-bag.js');
  ensureScript('sq-favorite-card-controls.js');
  ensureScript('sq-mobile-interaction-authority-v1.js');
  ensureScript('sq-expanded-direct-prefetch-v1.js');

  const loadRecommendationBridge = () => {
    if (/^\/products\//.test(location.pathname) || document.querySelector('[data-sq-smart-picks],product-recommendations,[data-product-recommendations],.premium-recommend-card-shell')) {
      ensureScript('sq-product-recommend-control-bridge-v1.js');
    }
  };

  let expandedHelpersLoaded = false;
  const loadExpandedHelpers = () => {
    if (expandedHelpersLoaded) return;
    expandedHelpersLoaded = true;
    ensureScript('sq-expanded-card-safety-v1.js');
    /* sq-bag-post-close-collapse-v1.js retired: close state now has one owner,
       sq-universal-bag-closeout-v1.js, loaded by the expanded controller. */
  };

  const intentSelector = '.sq-universal-bag,[data-sq-universal-expanded-open],[data-lcs-favorite-expand],[data-sqyml2-expand],[data-lcs-recommend-expand],[data-pick-quick-open]';
  const onIntent = (event) => {
    const target = event.target instanceof Element ? event.target.closest(intentSelector) : null;
    if (target) loadExpandedHelpers();
  };

  document.addEventListener('pointerover', onIntent, { capture: true, passive: true });
  document.addEventListener('pointerdown', onIntent, { capture: true, passive: true });
  document.addEventListener('focusin', onIntent, true);

  /* Mobile direct-open owner. A normal tap opens the expanded card on the first
     gesture. A swipe remains a page scroll. preventDefault on the completed tap
     suppresses the browser's compatibility click, so the opener never fires twice. */
  let touchGesture = null;
  const TOUCH_DISTANCE = 12;
  const directTouchButton = (target) => target instanceof Element ? target.closest(`${intentSelector},.sq-universal-card-trigger`) : null;
  const excludedTouchButton = (button) => !button ||
    button.closest('[data-lcs-favorite-expanded]') ||
    button.closest('#search-modal') ||
    button.matches('.quick-add__button--add,button[type="submit"][name="add"]');

  document.addEventListener('touchstart', (event) => {
    if (event.touches.length !== 1) { touchGesture = null; return; }
    const button = directTouchButton(event.target);
    if (excludedTouchButton(button)) { touchGesture = null; return; }
    const touch = event.touches[0];
    touchGesture = { button, x: touch.clientX, y: touch.clientY, moved: false };
    loadExpandedHelpers();
  }, { capture: true, passive: true });

  document.addEventListener('touchmove', (event) => {
    if (!touchGesture || event.touches.length !== 1) return;
    const touch = event.touches[0];
    if (Math.hypot(touch.clientX - touchGesture.x, touch.clientY - touchGesture.y) > TOUCH_DISTANCE) {
      touchGesture.moved = true;
    }
  }, { capture: true, passive: true });

  const openDirect = (button, attempt = 0) => {
    const api = window.SQUniversalExpandedBag;
    if (api?.openFrom) {
      void api.openFrom(button);
      return;
    }
    if (attempt < 8) setTimeout(() => openDirect(button, attempt + 1), 20);
  };

  document.addEventListener('touchend', (event) => {
    const gesture = touchGesture;
    touchGesture = null;
    if (!gesture || gesture.moved || event.changedTouches.length !== 1) return;
    const touch = event.changedTouches[0];
    if (Math.hypot(touch.clientX - gesture.x, touch.clientY - gesture.y) > TOUCH_DISTANCE) return;
    const button = directTouchButton(event.target);
    if (button !== gesture.button || excludedTouchButton(button)) return;
    if (event.cancelable) event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    loadExpandedHelpers();
    openDirect(button);
  }, { capture: true, passive: false });

  document.addEventListener('touchcancel', () => { touchGesture = null; }, { capture: true, passive: true });

  /* Warm the small expanded-card safety helper after first paint. It stays lazy
     for initial rendering but is normally ready before the first shopping tap. */
  const warmExpanded = () => loadExpandedHelpers();
  if ('requestIdleCallback' in window) window.requestIdleCallback(warmExpanded, { timeout: 1200 });
  else setTimeout(warmExpanded, 700);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', loadRecommendationBridge, { once: true });
  else loadRecommendationBridge();
  document.addEventListener('shopify:section:load', loadRecommendationBridge);
})();
